<div *ngIf="isVisible" class="modal-overlay" (click)="onClose()">
  <div class="modal-content" (click)="onModalClick($event)">
    <!-- Modal Header -->
    <div class="modal-header">
      <h2 class="modal-title">Attendance Records - {{ getEmployeeFullName() }}</h2>
      <button class="close-button" (click)="onClose()" aria-label="Close modal">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15 5L5 15M5 5L15 15"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>

    <!-- Modal Body -->
    <div class="modal-body">
      <!-- Custom Period Section -->
      <div class="filter-section">
        <label class="section-label">Custom Period</label>
        <div class="filter-controls">
          <div class="date-inputs">
            <div class="date-input-group">
              <label class="date-label" for="attendance-start-date">Select start date</label>
              <div class="date-field">
                <input
                  id="attendance-start-date"
                  class="date-input"
                  matInput
                  name="startDate"
                  [matDatepicker]="startCal"
                  [max]="endDate || locationTodayDate"
                  [(ngModel)]="startDate"
                  placeholder="dd-mm-yyyy"
                  (click)="startCal.open()"
                  readonly
                />
                <mat-datepicker-toggle class="date-toggle" [for]="startCal"></mat-datepicker-toggle>
                <mat-datepicker #startCal></mat-datepicker>
              </div>
            </div>
            <div class="date-input-group">
              <label class="date-label" for="attendance-end-date">Select end date</label>
              <div class="date-field">
                <input
                  id="attendance-end-date"
                  class="date-input"
                  matInput
                  name="endDate"
                  [matDatepicker]="endCal"
                  [min]="startDate"
                  [max]="locationTodayDate"
                  [(ngModel)]="endDate"
                  placeholder="dd-mm-yyyy"
                  (click)="endCal.open()"
                  readonly
                />
                <mat-datepicker-toggle class="date-toggle" [for]="endCal"></mat-datepicker-toggle>
                <mat-datepicker #endCal></mat-datepicker>
              </div>
            </div>
            <button class="search-button" (click)="onSearch()" [disabled]="!startDate || !endDate">
              Search
            </button>
          </div>
          <button class="download-csv-button" (click)="onDownloadCSV()">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M8 11L5 8L6.5 8L6.5 4L9.5 4L9.5 8L11 8L8 11Z" fill="currentColor" />
              <path d="M2 2L2 14L14 14L14 2L2 2ZM3 3L13 3L13 13L3 13L3 3Z" fill="currentColor" />
            </svg>
            Download CSV
          </button>
        </div>
      </div>

      <!-- Attendance Table -->
      <div class="table-container">
        <div class="table-wrapper" *ngIf="!isLoading">
          <table class="attendance-table">
            <thead>
              <tr>
                <th class="sortable" (click)="onSortDate()">
                  Date
                  <span class="sort-icon" *ngIf="sortColumn === 'date'">
                    {{ sortDirection === 'asc' ? '↑' : '↓' }}
                  </span>
                </th>
                <th>Day</th>
                <th>Status</th>
                <th>Check-in</th>
                <th>Checkout</th>
                <th>Hours</th>
                <th>Break Start</th>
                <th>Break End</th>
                <th>Break Duration</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let record of getFilteredRecords(); trackBy: trackByRecordId">
                <td>{{ formatDate(record.date) }}</td>
                <td>{{ getDayOfWeek(record.date) }}</td>
                <td>
                  <span class="status-badge" [ngClass]="getStatusBadgeClass(record.status)">
                    {{ getStatusLabel(record.status) }}
                  </span>
                </td>
                <td>{{ formatTime(record.check_in || record.check_in_local || null) }}</td>
                <td>{{ formatTime(record.check_out || record.check_out_local || null) }}</td>
                <td>{{ formatHours(record.work_hours, record) }}</td>
                <td>{{ formatBreakTime(getBreakStart(record)) }}</td>
                <td>{{ formatBreakTime(getBreakEnd(record)) }}</td>
                <td>{{ formatBreakDuration(record.break_hours, record) }}</td>
              </tr>
            </tbody>
          </table>

          <!-- Empty State -->
          <div *ngIf="getFilteredRecords().length === 0" class="empty-state">
            <p>No attendance records found for the selected period.</p>
          </div>
        </div>

        <!-- Loading State -->
        <div *ngIf="isLoading" class="loading-state">
          <div class="loading-spinner"></div>
          <p>Loading attendance records...</p>
        </div>

        <!-- Error State -->
        <div *ngIf="errorMessage && !isLoading" class="error-state">
          <p>{{ errorMessage }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
